<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-accept="saveRecord" @vm-close="close" @vm-action="deleteQuotationConfirm(newRecord)" :vm-action="true" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="false" :vm-is-valid="!$v.newRecord.$invalid" :vm-active="isModalAmountVisible" vm-title='Amount')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12" v-shortcuts="[{ shortcut: [ 'enter', ], callback: saveRecord, push: true, focus: true },]")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-select(:placeholder='$t("projects.currency_placeholder")' :danger="$v.newRecord.currency.$invalid && $v.newRecord.currency.$model" :danger-text="$t('validation.required', { attribute: $t('projects.currency') })" v-model="newRecord.currency" :label='$t("projects.currency")')
            vm-select-item(:key="index" :value="item.id" :text="item.name" v-for="(item,index) in currency")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-currency(:placeholder='$t("projects.amount_placeholder")' :danger="$v.newRecord.amount.$invalid && $v.newRecord.amount.$model" v-model="newRecord.amount" :label='$t("projects.amount")')
</template>

<script>
import { required } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Quotes')

export default {
  name: 'ModalQuoteAmount',
  data: () => ({
    currency: [
      {
        name: 'USD',
        id: 1
      },
      {
        name: 'MXN',
        id: 2
      }
    ]
  }),
  props: {
    newRecord: {
      type: Object
    }
  },
  validations: {
    newRecord: {
      currency: {
        required
      },
      amount: {
        required
      }
    }
  },
  computed: {
    ...mapGetters([
      'isModalAmountVisible',
      'quoteCatalog'
    ])
  },
  methods: {
    ...mapActions([
      'updateQuoteAmount',
      'setModalAmountVisible',
      'loadCatalog'
    ]),
    saveRecord () {
      this.updateQuoteAmount(this.newRecord)
    },
    autoCompleteFunc (value, url) {
      this.loadCatalog({ filter: value, url: url })
    },
    close () {
      this.setModalAmountVisible(false)
    }
  }
}
</script>
